(function ($) {
	$(function () {

    $('[data-expand-link]').each(function () {
      var $container = $(this),
        $anchor = $container.find('a')
      ;

      if ($anchor.length == 0) return;

      $container.addClass('clickable');

      $container.on('click', function (e) {
        let $target = $(e.target);
        if ($target.is('a') || $target.closest('a').length > 0) return;
        $anchor.first()[0].click();
      })
    })

	});
  })(jQuery);
